__turbopack_context__.v({
  "linkWrap": "L8cKUa_linkWrap",
  "menuItem": "L8cKUa_menuItem",
  "menuItemActive": "L8cKUa_menuItemActive",
});
